
export default {
    name: 'historique-ordonnance',
    components: {},
    props: {
        historique: Object
    },
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        /**
         * Copie les lignes de cette ordonnance passée dans un « panier » local.
         * À la prochaine ouverture de la modale de prescription, un badge
         * « Reprendre l'ordonnance du … » permet de tout pré-remplir en 1 clic.
         */
        represcrire() {
            const lignes = (this.historique.data.ordonnances || [])
                .filter(p => p.medicament)
                .map(p => ({
                    medicament_stock: p.medicament_stock || null,
                    medicament_libelle: p.medicament,
                    interne: p.interne == 1,
                    quantite: p.quantite || 1,
                    posologie: p.posologie || '',
                    conditionnement: p.conditionnement || '',
                    prix: p.prix || 0,
                    _poso: { dose: 1, freq: 0, duree: 3 }
                }))
            if (!lignes.length) return

            const auth = this.$store.getters['authInfo']
            const userId = (auth && (auth.id || (auth.user && auth.user.id))) || 0
            const panier = {
                date: this.formatDateToDmY(this.historique.date),
                reference: this.historique.data.reference || '',
                lignes: lignes
            }
            try {
                localStorage.setItem('ordo_represc_' + userId, JSON.stringify(panier))
                this.successToast('Ordonnance copiée — ouvrez « Nouveau » dans Ordonnances pour l\'appliquer')
            } catch (e) { /* stockage indisponible */ }
        }
    }
}


